import {Pipe, PipeTransform} from '@angular/core';
import {ReportExtensions} from '@spa/api';
import {Language} from '../language';
import {LanguageService} from '../language.service';

@Pipe({
	name: 'formatPercentage'
})
export class FormatPercentagePipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: number, maxDigits: number = 2, minDigits: number = 2): string {
		let result = ReportExtensions.toDecimalString(
			value,
			maxDigits,
			minDigits,
			false);

		if (this.languageService.getCurrentLanguage() === Language.Bulgarian) {
			result = result.replace(/,/g, ' ');
			result = result.replace('.', ',');
		}

		return `${result}%`;
	}
}
